/* Auto pack pricing. If the cart adds up to exactly 2 or 3 single 1L bottles,
   swap it for the matching pack variant so the buyer gets the pack price without
   having to find the pack picker. 4 or more bottles are left alone.
   ES5, guarded, must never break the cart.

   v4, 8 Aug. Two changes from v3:

   1. Bottles are now counted from PACKS as well as singles. v3 only counted
      singles, so a cart holding the two pack plus one single (which is exactly
      what the sticky bar's "grab a third" upsell produces) was invisible to it:
      count came out as 1, evaluate returned, and the shopper paid $70 + $39.99 =
      $109.99 for three bottles that cost $95.00 as a pack. Now the two pack is
      decomposed back into its scents, so the same swap logic handles it.

   2. FF|FF|FF was missing from PACK3. It exists in the store
      (46931109871815) and was simply absent from the table, so a fragrance free
      three pack silently declined to swap. Every combination is now present:
      10 pairs and 20 triples, checked against the store by
      scripts/pack-variant-map.mjs.

   Permutation twins: the store carries a variant per ORDER of scents, so
   LEM|MAN and MAN|LEM are different variant ids at the same price and SKU. The
   tables below hold one canonical id per sorted combination, which is why keys
   are always built with .sort(). */
(function () {
  "use strict";
  if (window.__hkPack) return; window.__hkPack = true;
  if (!window.fetch || !window.JSON) return;

  var SINGLES = { 46931107086535: "LEM", 46931107119303: "MAN", 46931107152071: "PEP", 46931107184839: "FF" };

  var PACK2 = { "FF|FF": 46931107741895, "FF|LEM": 46931107348679, "FF|MAN": 46931107479751,
    "FF|PEP": 46931107610823, "LEM|LEM": 46931107250375, "LEM|MAN": 46931107283143,
    "LEM|PEP": 46931107315911, "MAN|MAN": 46931107414215, "MAN|PEP": 46931107446983,
    "PEP|PEP": 46931107578055 };

  var PACK3 = { "FF|FF|FF": 46931109871815, "FF|FF|LEM": 46931108298951, "FF|FF|MAN": 46931108823239,
    "FF|FF|PEP": 46931109347527, "FF|LEM|LEM": 46931107905735, "FF|LEM|MAN": 46931108036807,
    "FF|LEM|PEP": 46931108167879, "FF|MAN|MAN": 46931108561095, "FF|MAN|PEP": 46931108692167,
    "FF|PEP|PEP": 46931109216455, "LEM|LEM|LEM": 46931107807431, "LEM|LEM|MAN": 46931107840199,
    "LEM|LEM|PEP": 46931107872967, "LEM|MAN|MAN": 46931107971271, "LEM|MAN|PEP": 46931108004039,
    "LEM|PEP|PEP": 46931108135111, "MAN|MAN|MAN": 46931108495559, "MAN|MAN|PEP": 46931108528327,
    "MAN|PEP|PEP": 46931108659399, "PEP|PEP|PEP": 46931109183687 };

  /* Reverse lookup, built once: variant id -> the scents that pack contains.
     Covers the permutation twins too, because any id the shopper actually has in
     their cart has to decompose, not just our canonical one. Twins are not in
     the tables, so an unknown pack id is treated as "not ours" and left alone,
     which is the safe direction. */
  /* Every pack variant in the store, generated from it on 8 Aug by
     scripts/pack-twins-and-kit-2026-08-08.mjs, not written by hand.

     The store carries one variant per ORDER of scents, so LEM|MAN and MAN|LEM
     are different ids at the same price and SKU. v4 built this map from the
     canonical tables alone, which meant a pack bought straight from the product
     picker in any other order was unrecognisable: it counted as a foreign item,
     the shopper got no third bottle offer, and the swap left the cart alone.
     Values are the sorted key, so they index straight into PACK2 and PACK3. */
  var PACK_ALL = {
    46931107250375: "LEM|LEM", 46931107283143: "LEM|MAN", 46931107315911: "LEM|PEP",
    46931107348679: "FF|LEM", 46931107381447: "LEM|MAN", 46931107414215: "MAN|MAN",
    46931107446983: "MAN|PEP", 46931107479751: "FF|MAN", 46931107512519: "LEM|PEP",
    46931107545287: "MAN|PEP", 46931107578055: "PEP|PEP", 46931107610823: "FF|PEP",
    46931107643591: "FF|LEM", 46931107676359: "FF|MAN", 46931107709127: "FF|PEP",
    46931107741895: "FF|FF", 46931107807431: "LEM|LEM|LEM", 46931107840199: "LEM|LEM|MAN",
    46931107872967: "LEM|LEM|PEP", 46931107905735: "FF|LEM|LEM", 46931107938503: "LEM|LEM|MAN",
    46931107971271: "LEM|MAN|MAN", 46931108004039: "LEM|MAN|PEP", 46931108036807: "FF|LEM|MAN",
    46931108069575: "LEM|LEM|PEP", 46931108102343: "LEM|MAN|PEP", 46931108135111: "LEM|PEP|PEP",
    46931108167879: "FF|LEM|PEP", 46931108200647: "FF|LEM|LEM", 46931108233415: "FF|LEM|MAN",
    46931108266183: "FF|LEM|PEP", 46931108298951: "FF|FF|LEM", 46931108331719: "LEM|LEM|MAN",
    46931108364487: "LEM|MAN|MAN", 46931108397255: "LEM|MAN|PEP", 46931108430023: "FF|LEM|MAN",
    46931108462791: "LEM|MAN|MAN", 46931108495559: "MAN|MAN|MAN", 46931108528327: "MAN|MAN|PEP",
    46931108561095: "FF|MAN|MAN", 46931108593863: "LEM|MAN|PEP", 46931108626631: "MAN|MAN|PEP",
    46931108659399: "MAN|PEP|PEP", 46931108692167: "FF|MAN|PEP", 46931108724935: "FF|LEM|MAN",
    46931108757703: "FF|MAN|MAN", 46931108790471: "FF|MAN|PEP", 46931108823239: "FF|FF|MAN",
    46931108856007: "LEM|LEM|PEP", 46931108888775: "LEM|MAN|PEP", 46931108921543: "LEM|PEP|PEP",
    46931108954311: "FF|LEM|PEP", 46931108987079: "LEM|MAN|PEP", 46931109019847: "MAN|MAN|PEP",
    46931109052615: "MAN|PEP|PEP", 46931109085383: "FF|MAN|PEP", 46931109118151: "LEM|PEP|PEP",
    46931109150919: "MAN|PEP|PEP", 46931109183687: "PEP|PEP|PEP", 46931109216455: "FF|PEP|PEP",
    46931109249223: "FF|LEM|PEP", 46931109281991: "FF|MAN|PEP", 46931109314759: "FF|PEP|PEP",
    46931109347527: "FF|FF|PEP", 46931109380295: "FF|LEM|LEM", 46931109413063: "FF|LEM|MAN",
    46931109445831: "FF|LEM|PEP", 46931109478599: "FF|FF|LEM", 46931109511367: "FF|LEM|MAN",
    46931109544135: "FF|MAN|MAN", 46931109576903: "FF|MAN|PEP", 46931109609671: "FF|FF|MAN",
    46931109642439: "FF|LEM|PEP", 46931109675207: "FF|MAN|PEP", 46931109707975: "FF|PEP|PEP",
    46931109740743: "FF|FF|PEP", 46931109773511: "FF|FF|LEM", 46931109806279: "FF|FF|MAN",
    46931109839047: "FF|FF|PEP", 46931109871815: "FF|FF|FF"
  };

  var PACK_CONTENTS = {};
  (function buildContents() {
    var id;
    for (id in PACK_ALL) if (PACK_ALL.hasOwnProperty(id)) PACK_CONTENTS[id] = PACK_ALL[id].split("|");
  })();

  /* Verified against the Admin API 8 Aug: single $39.99, 2 pack $70.00,
     3 pack $95.00. The sticky bar quotes these, so they live here with the
     variant tables rather than being typed a second time in hk-cro.js. */
  var SAVE2_CENTS = 998;
  var SAVE3_CENTS = 2097;

  var swapping = false;

  function toast(msg) {
    var el = document.createElement("div");
    el.textContent = msg;
    el.style.cssText = "position:fixed;left:50%;bottom:84px;transform:translateX(-50%);background:#4F7A52;color:#fff;padding:12px 20px;border-radius:24px;font-size:15px;z-index:9999;box-shadow:0 4px 16px rgba(0,0,0,.25);transition:opacity .4s";
    document.body.appendChild(el);
    setTimeout(function () { el.style.opacity = "0"; setTimeout(function () { el.remove(); }, 500); }, 3800);
  }

  /* Tell the theme the cart changed so the drawer re-renders in place. Horizon's
     cart-items component reads detail.data.sections; with none supplied it falls
     back to sectionRenderer.renderSection(cache:false), a fresh server render. */
  function notifyCartUpdated() {
    fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var ev;
        try { ev = new Event("cart:update", { bubbles: true }); }
        catch (e) { ev = document.createEvent("Event"); ev.initEvent("cart:update", true, false); }
        ev.detail = { resource: cart, sourceId: "hk-pack-upgrade", data: { source: "hk-pack-upgrade", itemCount: cart.item_count } };
        document.dispatchEvent(ev);
      })
      .catch(function () {});
  }

  /* What is in the cart, in bottles, whatever shape it is held in. */
  function summarise(cart) {
    var scents = [], updates = {}, lines = 0, foreign = 0, already = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var single = SINGLES[it.variant_id];
      var contents = PACK_CONTENTS[it.variant_id];
      if (single) {
        for (var n = 0; n < it.quantity; n++) scents.push(single);
        updates[it.variant_id] = 0;
        lines++;
      } else if (contents) {
        for (var q = 0; q < it.quantity; q++) {
          for (var c = 0; c < contents.length; c++) scents.push(contents[c]);
        }
        updates[it.variant_id] = 0;
        lines++;
        already = it.variant_id;
      } else if (it.final_line_price > 0 && it.handle !== "starter-pack") {
        foreign++;      /* something that is not ours: do not touch this cart */
      }
    }
    return { scents: scents, updates: updates, lines: lines, foreign: foreign, already: already };
  }

  function evaluate() {
    if (swapping) return;
    fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var s = summarise(cart);
        var count = s.scents.length;
        if (count !== 2 && count !== 3) return;
        if (s.foreign) return;

        var packKey = s.scents.sort().join("|");
        var packId = count === 2 ? PACK2[packKey] : PACK3[packKey];
        if (!packId) return;

        /* Already exactly right: one pack line, nothing else. Without this the
           notifyCartUpdated below would re-enter evaluate forever, because a
           correct three pack still counts as three bottles. */
        if (s.lines === 1 && s.already && String(s.already) === String(packId)) return;

        swapping = true;
        /* One request does the whole swap: the pack goes in and the singles go
           to zero in the same /cart/update call. Shopify applies it atomically,
           so a sold-out pack changes nothing, and it saves a full round trip
           over the old add-then-remove. */
        var updates = {}; for (var k in s.updates) updates[k] = s.updates[k];
        var have = 0; for (var q = 0; q < cart.items.length; q++) if (String(cart.items[q].variant_id) === String(packId)) have = cart.items[q].quantity;
        updates[String(packId)] = have + 1;
        fetch("/cart/update.js", { method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: updates }) })
          .then(function (r) {
            swapping = false;
            if (r && r.ok) {
              toast(count === 2 ? "Pack price applied. Two bottles for $70." : "Three pack price applied. Free Express Post included.");
              notifyCartUpdated();
            }
          })
          .catch(function () { swapping = false; });
      })
      .catch(function () {});
  }

  var SINGLE_LIST = [
    { id: 46931107086535, code: "LEM", name: "Lemon Myrtle + Eucalyptus" },
    { id: 46931107119303, code: "MAN", name: "Mandarin Peel + Rosemary" },
    { id: 46931107152071, code: "PEP", name: "Peppermint + Pine Needle" },
    { id: 46931107184839, code: "FF",  name: "Fragrance Free" }
  ];

  window.HK_PACK = {
    VER: "2026-08-08e",
    SINGLES: SINGLES,
    SINGLE_LIST: SINGLE_LIST,
    PACK2: PACK2,
    PACK3: PACK3,
    PACK_CONTENTS: PACK_CONTENTS,
    SAVE2_CENTS: SAVE2_CENTS,
    SAVE3_CENTS: SAVE3_CENTS,
    /* What the cart holds, in bottles. The sticky bar uses this to decide
       whether to offer a second bottle or a third. */
    summarise: function (cart) { return summarise(cart); },
    evaluate: evaluate
  };

  try { var msg = sessionStorage.getItem("hkPackToast"); if (msg) { sessionStorage.removeItem("hkPackToast"); setTimeout(function () { toast(msg); }, 600); } } catch (e) {}

  document.addEventListener("cart:update", function () { setTimeout(evaluate, 120); });
  function boot() { setTimeout(evaluate, 1000); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
